import { inherits as _inherits, createSuper as _createSuper, classCallCheck as _classCallCheck, createClass as _createClass, defineProperty as _defineProperty } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import propTypes from '../../../node_modules/prop-types/index.js';
import React from 'react';
import classnames from '../../../node_modules/classnames/index.js';
import { styled, useThemeProps } from '@mui/material';
import Field from '../Field.js';
import withFormObject$1 from '../../../cinnamon-core/es/components/forms/withFormObject.js';
import { createComponentSlot } from '../../../modules/styling/theme.js';

var componentRoot = createComponentSlot({
  name: "CinFormObject",
  slot: "Root"
});

var ObjectFieldBase = /*#__PURE__*/function (_React$Component) {
  _inherits(ObjectFieldBase, _React$Component);

  var _super = _createSuper(ObjectFieldBase);

  function ObjectFieldBase() {
    _classCallCheck(this, ObjectFieldBase);

    return _super.apply(this, arguments);
  }

  _createClass(ObjectFieldBase, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          label = _this$props.label,
          labelProps = _this$props.labelProps,
          disabled = _this$props.disabled,
          children = _this$props.children,
          className = _this$props.className;
      return /*#__PURE__*/React.createElement(Field, {
        disabled: disabled,
        width: null,
        label: label,
        labelProps: labelProps,
        className: classnames(componentRoot.className, className)
      }, children);
    }
  }]);

  return ObjectFieldBase;
}(React.Component);

_defineProperty(ObjectFieldBase, "propTypes", {
  label: propTypes.node,
  labelProps: propTypes.any,
  className: propTypes.string,
  sx: propTypes.any,
  variant: propTypes.any,
  field: propTypes.string.isRequired,
  showErrors: propTypes.bool,
  allErrors: propTypes.bool,
  animateErrors: propTypes.oneOfType([propTypes.number, propTypes.bool]),
  disabled: propTypes.bool,
  readOnly: propTypes.bool,
  propagateUpdates: propTypes.any,
  children: propTypes.oneOfType([propTypes.node, propTypes.func])
});

var ConnectedObjectField = withFormObject$1({
  defaultProps: {}
})(ObjectFieldBase);
var ObjectFieldRoot = styled(ConnectedObjectField, componentRoot.styledOptions)(function (_ref) {
  var theme = _ref.theme;
  return {
    "> .CinForm-label:first-of-type": {
      marginBottom: theme.spacing(1.25)
    },
    // collapse the bottom margin of last field
    "> .CinForm-field + .CinForm-errors:last-child": {
      marginTop: theme.spacing(-3),
      ".CinForm-error:first-of-type": {
        marginTop: theme.spacing(1)
      }
    }
  };
});
/**
 * Nests child form field data within an object
 */

var ObjectField = function ObjectField(props) {
  var rootProps = useThemeProps({
    props: props,
    name: componentRoot.name
  });
  return /*#__PURE__*/React.createElement(ObjectFieldRoot, rootProps);
};

var ObjectField$1 = ObjectField;

export { ObjectField$1 as default };
